<p-inputgroup class="!items-center">
  <p-inputgroup-addon [class.h-11]="size === 'small'" [class.h-12]="!size">
    <p-button
      [icon]="defaultIcon.Previous"
      styleClass="vertical-align-middle"
      (click)="moveBackWeek()"
      pTooltip="Prior Week"
    />
  </p-inputgroup-addon>
  <p-float-label [variant]="labelLocation">
    <p-date-picker
      #calendar
      [showIcon]="true"
      [(ngModel)]="controlValue"
      inputId="weekSelectionId"
      [showClear]="false"
      appendTo="body"
      inputStyleClass="date-Format"
      (onSelect)="onChange()"
      (onblur)="onChange()"
      (onClear)="onChange()"
      (onShow)="onShow()"
      (onClose)="onClose()"
      inputStyleClass="date-Format"
      [touchUI]="layoutService.mobile$ | async"
      class="flex grow"
      [showButtonBar]="true"
      [required]="required"
      [size]="size"
    />
    @if (label) {
      <label for="weekSelectionId">{{ label }}</label>
    }
  </p-float-label>
  <p-inputgroup-addon [class.h-11]="size === 'small'" [class.h-12]="!size" class="!hidden sm:!flex">
    <p-button [icon]="defaultIcon.Today" styleClass="vertical-align-middle" (click)="moveToToday()" pTooltip="Today" />
  </p-inputgroup-addon>
  <p-inputgroup-addon [class.h-11]="size === 'small'" [class.h-12]="!size">
    <p-button
      [icon]="defaultIcon.Next"
      styleClass="vertical-align-middle"
      (click)="moveForwardWeek()"
      pTooltip="Next Week"
    />
  </p-inputgroup-addon>
</p-inputgroup>
